import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_foodie_pantry: FaireThemeEntity = {
  token: "discovery_theme_foodie-pantry",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Foodie Pantry Staples",
  description: "Gourmet ingredients and pantry must-haves",
  bgColor: "#F5ECD4",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
